import { CHANGE_TAB } from "../shared/constants";
import { flightsSum } from "../shared/utils";

export const initialTabState = {
	currentStretch: "outbound"
};

export const flightsTab = (state = initialTabState, action) => {
	switch (action.type) {
		case CHANGE_TAB:
			return { currentStretch: action.currentStretch };
		default:
			return state;
	}
};
